export const listData = {
    totalCount: 3,
    totalPage: 1,
    curPage: 1,
    curLimit: 15,
    entitys: [
        {
            id: 1,
            ctdate: 1755148289880,
            mddate: 1755148485239,
            customCondition: null,
            orderCondition: null,
            offset: null,
            limit: null,
            userId: 1546,
            contractName: '穆浩楠信任桥商城用户三合一法律合同.pdf',
            flowId: 'yDt4AUUckp9qdr15Ux3gF9VyPTrAKrG9',
            contractStatus: 1,
        },
        {
            id: 2,
            ctdate: 1755273551990,
            mddate: 1755279772890,
            customCondition: null,
            orderCondition: null,
            offset: null,
            limit: null,
            userId: 1549,
            contractName: '张岐明信任桥商城用户三合一法律合同.pdf',
            flowId: 'yDt4lUUckp9q3247Uxc56S883i8pSwfc',
            contractStatus: 4,
        },
        {
            id: 3,
            ctdate: 1755148289880,
            mddate: 1755148485239,
            customCondition: null,
            orderCondition: null,
            offset: null,
            limit: null,
            userId: 1705,
            contractName: '穆浩楠1信任桥商城用户三合一法律合同.pdf',
            flowId: 'yDt4ZUUckp9jqor9UxH9A8AvmQBPkCXg',
            contractStatus: 4,
        },
    ],
};
// 合同状态枚举
export const statusArr = [
    { key: 1, value: '合同创建' },
    { key: 2, value: '合同签署中' },
    { key: 3, value: '合同拒签' },
    { key: 4, value: '合同签署完成' },
    { key: 5, value: '合同过期' },
    { key: 6, value: '合同撤回' },
    { key: 8, value: '合同待填写' },
    { key: 9, value: '合同填写中' },
];
